var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevroninline = function SvgChevroninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0976311 0.087868C0.227806 -0.0292893 0.438861 -0.0292893 0.569036 0.087868L3 2.27574L5.43096 0.087868C5.56114 -0.0292893 5.77219 -0.0292893 5.90237 0.087868C6.03254 0.205025 6.03254 0.394975 5.90237 0.512132L3.2357 2.91213C3.10553 3.02929 2.89447 3.02929 2.7643 2.91213L0.0976311 0.512132C-0.0325437 0.394975 -0.0325437 0.205025 0.0976311 0.087868Z",
    fill: "#07264A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0976311 0.087868C0.227806 -0.0292893 0.438861 -0.0292893 0.569036 0.087868L3 2.27574L5.43096 0.087868C5.56114 -0.0292893 5.77219 -0.0292893 5.90237 0.087868C6.03254 0.205025 6.03254 0.394975 5.90237 0.512132L3.2357 2.91213C3.10553 3.02929 2.89447 3.02929 2.7643 2.91213L0.0976311 0.512132C-0.0325437 0.394975 -0.0325437 0.205025 0.0976311 0.087868Z",
    fill: "#07264A"
  })));
};

export default SvgChevroninline;